import { connect } from "react-redux";
import React, { Fragment, useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { Button, ButtonGroup, Card, CardBody, CardTitle, Input, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { Colxx, Separator } from "../../../../../components/common/CustomBootstrap";
import Validation from "../../../../../components/Validation";
import { AxiosAPI, getGroupID } from "../../../../../helpers/AxiosAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots, faLink } from "@fortawesome/free-solid-svg-icons";
import IntlMessages from "../../../../../helpers/IntlMessages";
import { putAPI_Delete_Response, putAPI_Update_Response, gAPI_Response_By_Code } from "../../../../../constants/APIs";
import { NotificationManager } from "../../../../../components/common/react-notifications";
import ImageGallery from './../../propinfo/gallery';
function WelcomeMessage({
    msg,
    AllButtons,
    locale,
    integrationProperties,
    allProperties,
    propertyId
}) {
    const [titleInput, setTitleInput] = useState('');
    const [subTitleInput, setSubTitleInput] = useState('');
    const [linkInput, setLinkInput] = useState('');
    const [buttonList, setButtonList] = useState([]);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [galleryVisible, setGalleryVisible] = useState(false);
    const [open, setOpen] = useState(false);
    const [msgs, setMsgs] = useState([]);
    const [postData, setPostData] = useState({
        GroupId: getGroupID(),
        Code: 'business_domain_welcome_message',
        Language: 'en-US',
        Channel: 'WebsiteDirectLine',
        PropertyId: (integrationProperties !== undefined && integrationProperties.length === 1) ? integrationProperties[0] : undefined,
        Default: null,
        Overrides: {},
        UserName: ''
    });
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };
    const togglegallery = () => {
        setGalleryVisible(!galleryVisible);
    };

    const selectedImage = (link) => {
        setLinkInput(link.src);
        setPostData({
            ...postData,
            Default: {
                Title: titleInput,
                SubTitle: subTitleInput,
                ImageUrl: link.src
            },
        });
    };

    const handleDelete = (code) => {
        let data;
        if (postData.PropertyId !== undefined) {
            data = {
                GroupId: getGroupID(),
                PropertyId: postData.PropertyId,
                Language: 'en-US',
                Channel: 'WebsiteDirectLine',
            };
        } else {
            data = {
                GroupId: getGroupID(),
                Language: 'en-US',
                Channel: 'WebsiteDirectLine',
                UserName: ''
            };
        }
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Delete_Response}/${'business_domain_welcome_message'}`,
            data: data,
        })
            .then((res) => {
                //console.log(res.data);
                toggle();
            })
            .finally(
                setTimeout(() => {
                    reloadBotResponse(postData.PropertyId);
                }, 1000)
            )
            .catch((err) => {
                console.log(err);
            });
    };
    const handleTextChange = (e) => {
        setTitleInput(e.target.value);
        setPostData({
            ...postData,
            Default: {
                Title: e.target.value,
                SubTitle: subTitleInput,
                ImageUrl: linkInput,
            },
        });
    };

    const handleSubTitleChange = (e) => {
        setSubTitleInput(e.target.value);
        setPostData({
            ...postData,
            Default: {
                Title: titleInput,
                SubTitle: e.target.value,
                ImageUrl: linkInput,
            },
        });
    };

    const handleUrlChange = (e) => {
        setLinkInput(e.target.value);
        setPostData({
            ...postData,
            Default: {
                Title: titleInput,
                SubTitle: subTitleInput,
                ImageUrl: e.target.value,
            },
        });
    };

    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal
                                isOpen={galleryVisible}
                                toggle={togglegallery}
                                style={{ maxWidth: '1000px' }}
                            >
                                <ModalHeader toggle={togglegallery}>
                                    Select Image or Upload New Image
                                </ModalHeader>
                                <ModalBody>
                                    <ImageGallery
                                        propertyId={propertyId}
                                        selectedImage={selectedImage}
                                        togglegallery={togglegallery}
                                        hideUserUploads={false}
                                        searchText={''}
                                    />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    const reloadBotResponse = async (property_id) => {
        let url = `${gAPI_Response_By_Code}/?property_id=${property_id}&group_id=${getGroupID()}&lang=${locale === 'en' ? 'en-US' : locale
            }&code=business_domain_welcome_message`;

        // setIsLoading(true);
        // locale = lang;
        var languageCode = locale;
        if (locale === "zh-TW") {
            languageCode = "hk";
        }
        if (locale === "en") {
            languageCode = "en-US";
        }
        return await AxiosAPI({
            methed: 'get',
            url: url,
        })
            .then((res) => {
                if (res.data.response !== undefined) {
                    setPostData({
                        ...postData,
                        PropertyId: property_id,
                        Default: {
                            Title: res.data.response?.title,
                            SubTitle: res.data.response?.subtitle,
                            ImageUrl: res.data.response?.imageURL,
                        },
                    });
                    setTitleInput(res.data.response?.title);
                    setSubTitleInput(res.data.response?.subtitle);
                    setLinkInput(res.data.response?.imageURL);
                } else {
                    setTitleInput('');
                    setSubTitleInput('');
                    setLinkInput('');
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const generateButtonGroup = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                                    </span>
                                    This response will be deleted!
                                </ModalHeader>
                                <ModalBody>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete('business_domain_welcome_message')}
                                        size="xs"
                                    >
                                        <IntlMessages id='dashboards.delete' />
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        <IntlMessages id='pages.cancel' />
                                    </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };


    useEffect(() => {
        if (integrationProperties !== undefined && integrationProperties.length === 1) {
            reloadBotResponse(integrationProperties[0]);
            setPostData({ ...postData, PropertyId: integrationProperties[0] });
        }

    }, [propertyId]);

    const handleSave = async () => {
        try {
            return await AxiosAPI({
                method: 'put',
                url: putAPI_Update_Response,
                data: postData,
            })
                .then((res) => {
                    if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                        && res.data.Messages !== null && res.data.Messages.length > 0) {
                        setMsgs(res.data.Messages);
                        setOpen(true);
                    }
                    else {
                        NotificationManager.success(
                            '',
                            'Bot Response Updated.',
                            3000,
                            null,
                            null,
                            'success'
                        );
                        setTimeout(() => {
                            reloadBotResponse(postData.PropertyId);
                        }, 1000);
                    }
                })
                .finally(

            );
        } catch (error) {
            console.error(error);
        }
    };

    const handleProperty = (id) => {
        setPostData({ ...postData, PropertyId: id });
        reloadBotResponse(id);
    }

    const Editing = () => {
        return (
            <Fragment>
                {/* <pre>{JSON.stringify(postData, null, 2)}</pre> */}
                <div className="text-center my-2">
                    <h6>Welcome Message</h6>
                </div>
                <Separator className="my-2"></Separator>

                {(integrationProperties !== undefined && integrationProperties.length > 1) &&
                    <Fragment>
                        <CardTitle>
                            <Row>
                                <Colxx xxs="6">
                                    <div>
                                        Select Business
                                    </div>
                                </Colxx>
                            </Row>
                        </CardTitle>
                        <Row>
                            <Colxx xxs="12">
                                <Input
                                    type="select"
                                    value={postData.PropertyId}
                                    onChange={(e) => handleProperty(e.target.value)}
                                >
                                    <option value="">Please Select</option>
                                    {(allProperties !== undefined && allProperties.length > 0) &&
                                        allProperties.filter(f => integrationProperties.filter(i => i === f.id)).map((p) => {
                                            if (p.domains !== undefined && p?.domains[0]?.type !== undefined && p?.domains?.filter((f) => f.type === 'BusinessOperator' || f.type === 'UtilityProviders').length > 0)
                                                return <option value={p.id}>{p.name}</option>
                                        }
                                        )}
                                </Input>
                            </Colxx>
                        </Row>

                    </Fragment>
                }

                <CardTitle>
                    <Row>
                        <Colxx xxs="6">
                            <div>
                                <FontAwesomeIcon icon={faCommentDots} />
                                <span> </span>
                                <IntlMessages id="property.Title" />
                            </div>
                        </Colxx>
                    </Row>
                </CardTitle>
                <Row>
                    <Colxx xxs="12">
                        <Input
                            type="textarea"
                            value={titleInput}
                            onChange={handleTextChange}
                        />
                    </Colxx>
                </Row>
                <CardTitle>
                    <Row>
                        <Colxx xxs="6">
                            <div>
                                <FontAwesomeIcon icon={faCommentDots} />
                                <span> </span>
                                <IntlMessages id="property.SubTitle" />
                            </div>
                        </Colxx>
                    </Row>
                </CardTitle>
                <Row>
                    <Colxx xxs="12">
                        <Input
                            type="textarea"
                            value={subTitleInput}
                            onChange={handleSubTitleChange}
                        />
                    </Colxx>
                </Row>
                <CardTitle>
                    <Row>
                        <Colxx xxs="6">
                            <div>
                                <FontAwesomeIcon icon={faLink} />
                                <span> </span>
                                <IntlMessages id='dashboards.imagelink' />
                            </div>
                        </Colxx>
                    </Row>
                </CardTitle>
                <Row>
                    <Colxx xxs="10">
                        <Input
                            type="text"
                            value={linkInput}
                            onChange={handleUrlChange}
                        ></Input>
                    </Colxx>
                    <Colxx xxs="2"> <Button
                        color="primary"
                        outline
                        className="add-button mt-1"
                        size="xs"
                        onClick={togglegallery}
                    >
                        Browse
                    </Button></Colxx>
                </Row>
                {/* <Row>
                    <Colxx xxs="2">

                    </Colxx>
                    <Colxx xxs="10">
                        <div
                            className="float-left"
                            style={{ marginTop: ' 5px', marginBottom: '5px' }}
                        >

                        </div>
                    </Colxx>
                </Row> */}
                {ImageGalleryButton()}

                <div className="mt-4 text-center">
                    <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                        <Button color="primary" size="xs" onClick={handleSave}>
                            Save
                        </Button>
                    </ButtonGroup>
                </div>
                {generateButtonGroup()}
            </Fragment>
        );
    };
    return (
        <Card>
            <CardBody>{Editing()}</CardBody>
            <Validation open={open} messages={msgs} toggle={() => { setOpen(!open) }}></Validation>
        </Card>
    );
}

const mapStateToProps = ({ settings }) => {
    const { locale, propertyId } = settings;
    return {
        propertyId,
        locale,
    };
};

export default injectIntl(connect(mapStateToProps)(WelcomeMessage));